<template>
  <main class="w-full flex-grow p-6">
    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              What’s New
            </div>
            <div @click="showModalNews" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="">
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Title
              <div class="ml-8 font-normal">{{ news.title }}</div>
            </div>
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Description
              <!-- <div class="ml-8 font-normal">{{ news.description }}</div> -->
              <div class="ml-8 font-normal" v-html="news.description"></div>
            </div>

            <!-- ----------------- -->
            <!-- Promotion table -->
            <!-- ----------------- -->
            <h1 class="text-2xl">Promotion</h1>
            <div class="my-5">
              <table class="w-full mx-auto table-auto">
                <thead class="justify-between">
                  <tr class="bg-gray-600">
                    <th class="px-5 py-2">
                      <span class="text-gray-100 font-semibold">No</span>
                    </th>
                    <th class="px-16 py-2">
                      <span class="text-gray-100 font-semibold">Name</span>
                    </th>
                    <th class="px-16 py-2">
                      <span class="text-gray-100 font-semibold"
                        >Choose one Promo to highlight</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-gray-200">
                  <tr
                    v-for="(sos, index) in promotions"
                    :key="sos.id"
                    :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
                    class="bg-white border-b-2 border-gray-200"
                  >
                    <td class="px-5 py-2 text-center">
                      {{
                        table.current_page === 1
                          ? index + 1
                          : index +
                            1 +
                            (table.current_page - 1) * table.per_page
                      }}
                    </td>
                    <td class="text-center">
                      <button
                        class="font-bold text-app-default"
                        type="button"
                        @click="detailContent(sos.id)"
                      >
                        {{ sos.promotion_name }}
                      </button>
                    </td>
                    <td class="">
                      <div
                        class="flex items-center justify-evenly"
                        v-if="sos.id === deployedPromoId"
                      >
                        <span class="text-sm text-dark mb-3 font-bold">
                          Selected
                        </span>
                      </div>
                      <div class="flex items-center justify-evenly" v-else>
                        <button
                          class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
                          type="button"
                          @click="updateDeployedPromo(sos.id)"
                        >
                          Select
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- ----------------- -->
            <!-- Promotion Pagination -->
            <!-- ----------------- -->
            <div
              class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between mb-10"
            >
              <div>
                <p class="text-sm text-gray-700">
                  Showing
                  <span class="font-medium">
                    {{
                      table.current_page * table.per_page - table.per_page + 1
                    }}
                  </span>
                  to
                  <span class="font-medium">
                    {{ table.current_page * table.per_page }}
                  </span>
                  of
                  <span class="font-medium">{{ table.total }}</span>
                  results
                </p>
              </div>
              <div>
                <nav
                  class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                  aria-label="Pagination"
                >
                  <button
                    type="button"
                    @click="previewPage"
                    :disabled="table.current_page === 1"
                    class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  >
                    <span class="sr-only">Previous</span>
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>

                  <div
                    v-if="Math.ceil(table.total / table.per_page) < 5"
                    class=""
                  >
                    <button
                      v-for="pg in Math.ceil(table.total / table.per_page)"
                      :key="pg"
                      @click="findpage(pg)"
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page === pg
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{ pg }}
                    </button>
                  </div>
                  <div v-else class="">
                    <button
                      @click="findpage(1)"
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page === 1
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      1
                    </button>

                    <button
                      @click="
                        findpage(
                          table.current_page === 1
                            ? 2
                            : table.current_page === 2
                            ? 2
                            : table.current_page ===
                              Math.ceil(table.total / table.per_page)
                            ? table.current_page - 3
                            : table.current_page ===
                              Math.ceil(table.total / table.per_page) - 1
                            ? table.current_page - 2
                            : table.current_page - 1
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(table.total / table.per_page) - 1 ===
                          table.current_page
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page === 1
                          ? 'bg-white text-black'
                          : table.current_page === 2
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{
                        table.current_page === 1
                          ? 2
                          : table.current_page === 2
                          ? 2
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page)
                          ? table.current_page - 3
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page) - 1
                          ? table.current_page - 2
                          : table.current_page - 1
                      }}
                    </button>

                    <button
                      @click="
                        findpage(
                          table.current_page === 1
                            ? 3
                            : table.current_page === 2
                            ? 3
                            : table.current_page ===
                              Math.ceil(table.total / table.per_page) - 1
                            ? table.current_page - 1
                            : table.current_page ===
                              Math.ceil(table.total / table.per_page)
                            ? table.current_page - 2
                            : table.current_page
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(table.total / table.per_page) - 1 ===
                          table.current_page
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page ===
                        Math.ceil(table.total / table.per_page) - 1
                          ? 'bg-white text-black'
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page)
                          ? 'bg-white text-black'
                          : table.current_page === 1
                          ? 'bg-white text-black'
                          : table.current_page === 2
                          ? 'bg-white text-black'
                          : 'bg-app-default text-white',
                      ]"
                    >
                      {{
                        table.current_page === 1
                          ? 3
                          : table.current_page === 2
                          ? 3
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page) - 1
                          ? table.current_page - 1
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page)
                          ? table.current_page - 2
                          : table.current_page
                      }}
                    </button>

                    <button
                      @click="
                        findpage(
                          table.current_page === 1
                            ? 4
                            : table.current_page === 2
                            ? 4
                            : table.current_page ===
                              Math.ceil(table.total / table.per_page) - 1
                            ? Math.ceil(table.total / table.per_page) - 1
                            : table.current_page ===
                              Math.ceil(table.total / table.per_page)
                            ? table.current_page - 1
                            : table.current_page + 1
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(table.total / table.per_page) - 1 ===
                          table.current_page
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page ===
                        Math.ceil(table.total / table.per_page) - 2
                          ? 'bg-white text-black'
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page) - 3
                          ? 'bg-white text-black'
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page)
                          ? 'bg-white text-black'
                          : table.current_page > 1 &&
                            table.current_page <
                              Math.ceil(table.total / table.per_page) - 1
                          ? 'bg-white text-black'
                          : table.current_page === 1
                          ? 'bg-white text-black'
                          : 'bg-app-default text-white',
                      ]"
                    >
                      {{
                        table.current_page === 1
                          ? 4
                          : table.current_page === 2
                          ? 4
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page) - 1
                          ? Math.ceil(table.total / table.per_page) - 1
                          : table.current_page ===
                            Math.ceil(table.total / table.per_page)
                          ? table.current_page - 1
                          : table.current_page + 1
                      }}
                    </button>

                    <button
                      @click="findpage(Math.ceil(table.total / table.per_page))"
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page ===
                        Math.ceil(table.total / table.per_page)
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{ Math.ceil(table.total / table.per_page) }}
                    </button>
                  </div>

                  <!-- <button v-for="pg in Math.ceil(table.total / table.per_page)" :key="pg" @click="findpage(pg)" type="button" aria-current="page" class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium" :class="[table.current_page === pg ? 'bg-app-default text-white' : 'bg-white text-black']">
                    {{ pg }}
                  </button> -->
                  <button
                    type="button"
                    @click="nexPage"
                    :disabled="
                      Math.ceil(table.total / table.per_page) ===
                        table.current_page
                    "
                    class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  >
                    <span class="sr-only">Next</span>
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </nav>
              </div>
            </div>

            <!-- ----------------- -->
            <!-- Event Table -->
            <!-- ----------------- -->
            <h1 class="text-2xl">Event</h1>
            <div class="mt-2 my-5">
              <table class="w-full mx-auto table-auto">
                <thead class="justify-between">
                  <tr class="bg-gray-600">
                    <th class="px-5 py-2">
                      <span class="text-gray-100 font-semibold">No</span>
                    </th>
                    <th class="px-16 py-2">
                      <span class="text-gray-100 font-semibold">Name</span>
                    </th>
                    <th class="px-16 py-2">
                      <span class="text-gray-100 font-semibold"
                        >Choose one Event to highlight</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-gray-200">
                  <tr
                    v-for="(sos, index) in events"
                    :key="sos.id"
                    :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
                    class="bg-white border-b-2 border-gray-200"
                  >
                    <td class="px-5 py-2 text-center">
                      {{
                        table.current_page_event === 1
                          ? index + 1
                          : index +
                            1 +
                            (table.current_page_event - 1) *
                              table.per_page_event
                      }}
                    </td>
                    <td class="text-center">
                      <button
                        class="font-bold text-app-default"
                        type="button"
                        @click="detailEventContent(sos.id)"
                      >
                        {{ sos.event_name }}
                      </button>
                    </td>
                    <td class="">
                      <div
                        class="flex items-center justify-evenly"
                        v-if="sos.id === deployedEventId"
                      >
                        <span class="text-sm text-dark mb-3 font-bold">
                          Selected
                        </span>
                      </div>
                      <div class="flex items-center justify-evenly" v-else>
                        <button
                          class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
                          type="button"
                          @click="updateDeployedEvent(sos.id)"
                        >
                          Select
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- ----------------- -->
            <!-- Event Pagination -->
            <!-- ----------------- -->
            <div
              class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"
            >
              <div>
                <p class="text-sm text-gray-700">
                  Showing
                  <span class="font-medium">
                    {{
                      table.current_page_event * table.per_page_event -
                        table.per_page_event +
                        1
                    }}
                  </span>
                  to
                  <span class="font-medium">
                    {{ table.current_page_event * table.per_page_event }}
                  </span>
                  of
                  <span class="font-medium">{{ table.total_event }}</span>
                  results
                </p>
              </div>
              <div>
                <nav
                  class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                  aria-label="Pagination"
                >
                  <button
                    type="button"
                    @click="previewPage_event"
                    :disabled="table.current_page_event === 1"
                    class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  >
                    <span class="sr-only">Previous</span>
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>

                  <div
                    v-if="
                      Math.ceil(table.total_event / table.per_page_event) < 5
                    "
                    class=""
                  >
                    <button
                      v-for="pg_event in Math.ceil(
                        table.total_event / table.per_page_event
                      )"
                      :key="pg_event"
                      @click="findpage_event(pg_event)"
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_event === pg_event
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{ pg_event }}
                    </button>
                  </div>
                  <div v-else class="">
                    <button
                      @click="findpage_event(1)"
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_event === 1
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      1
                    </button>

                    <button
                      @click="
                        findpage_event(
                          table.current_page_event === 1
                            ? 2
                            : table.current_page_event === 2
                            ? 2
                            : table.current_page_event ===
                              Math.ceil(
                                table.total_event / table.per_page_event
                              )
                            ? table.current_page_event - 3
                            : table.current_page_event ===
                              Math.ceil(
                                table.total_event / table.per_page_event
                              ) -
                                1
                            ? table.current_page_event - 2
                            : table.current_page_event - 1
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(table.total_event / table.per_page_event) -
                          1 ===
                          table.current_page_event
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_event === 1
                          ? 'bg-white text-black'
                          : table.current_page_event === 2
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{
                        table.current_page_event === 1
                          ? 2
                          : table.current_page_event === 2
                          ? 2
                          : table.current_page_event ===
                            Math.ceil(table.total_event / table.per_page_event)
                          ? table.current_page_event - 3
                          : table.current_page_event ===
                            Math.ceil(
                              table.total_event / table.per_page_event
                            ) -
                              1
                          ? table.current_page_event - 2
                          : table.current_page_event - 1
                      }}
                    </button>

                    <button
                      @click="
                        findpage_event(
                          table.current_page_event === 1
                            ? 3
                            : table.current_page_event === 2
                            ? 3
                            : table.current_page_event ===
                              Math.ceil(
                                table.total_event / table.per_page_event
                              ) -
                                1
                            ? table.current_page_event - 1
                            : table.current_page_event ===
                              Math.ceil(
                                table.total_event / table.per_page_event
                              )
                            ? table.current_page_event - 2
                            : table.current_page_event
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(table.total_event / table.per_page_event) -
                          1 ===
                          table.current_page_event
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_event ===
                        Math.ceil(table.total_event / table.per_page_event) - 1
                          ? 'bg-white text-black'
                          : table.current_page_event ===
                            Math.ceil(table.total_event / table.per_page_event)
                          ? 'bg-white text-black'
                          : table.current_page_event === 1
                          ? 'bg-white text-black'
                          : table.current_page_event === 2
                          ? 'bg-white text-black'
                          : 'bg-app-default text-white',
                      ]"
                    >
                      {{
                        table.current_page_event === 1
                          ? 3
                          : table.current_page_event === 2
                          ? 3
                          : table.current_page_event ===
                            Math.ceil(
                              table.total_event / table.per_page_event
                            ) -
                              1
                          ? table.current_page_event - 1
                          : table.current_page_event ===
                            Math.ceil(table.total_event / table.per_page_event)
                          ? table.current_page_event - 2
                          : table.current_page_event
                      }}
                    </button>

                    <button
                      @click="
                        findpage_event(
                          table.current_page_event === 1
                            ? 4
                            : table.current_page_event === 2
                            ? 4
                            : table.current_page_event ===
                              Math.ceil(
                                table.total_event / table.per_page_event
                              ) -
                                1
                            ? Math.ceil(
                                table.total_event / table.per_page_event
                              ) - 1
                            : table.current_page_event ===
                              Math.ceil(
                                table.total_event / table.per_page_event
                              )
                            ? table.current_page_event - 1
                            : table.current_page_event + 1
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(table.total_event / table.per_page_event) -
                          1 ===
                          table.current_page_event
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_event ===
                        Math.ceil(table.total_event / table.per_page_event) - 2
                          ? 'bg-white text-black'
                          : table.current_page_event ===
                            Math.ceil(
                              table.total_event / table.per_page_event
                            ) -
                              3
                          ? 'bg-white text-black'
                          : table.current_page_event ===
                            Math.ceil(table.total_event / table.per_page_event)
                          ? 'bg-white text-black'
                          : table.current_page_event > 1 &&
                            table.current_page_event <
                              Math.ceil(
                                table.total_event / table.per_page_event
                              ) -
                                1
                          ? 'bg-white text-black'
                          : table.current_page_event === 1
                          ? 'bg-white text-black'
                          : 'bg-app-default text-white',
                      ]"
                    >
                      {{
                        table.current_page_event === 1
                          ? 4
                          : table.current_page_event === 2
                          ? 4
                          : table.current_page_event ===
                            Math.ceil(
                              table.total_event / table.per_page_event
                            ) -
                              1
                          ? Math.ceil(
                              table.total_event / table.per_page_event
                            ) - 1
                          : table.current_page_event ===
                            Math.ceil(table.total_event / table.per_page_event)
                          ? table.current_page_event - 1
                          : table.current_page_event + 1
                      }}
                    </button>

                    <button
                      @click="
                        findpage_event(
                          Math.ceil(table.total_event / table.per_page_event)
                        )
                      "
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_event ===
                        Math.ceil(table.total_event / table.per_page_event)
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{ Math.ceil(table.total_event / table.per_page_event) }}
                    </button>
                  </div>
                  <!-- <button v-for="pg_event in Math.ceil(table.total_event / table.per_page_event)" :key="pg_event" @click="findpage_event(pg_event)" type="button" aria-current="page" class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium" :class="[table.current_page_event === pg_event ? 'bg-app-default text-white' : 'bg-white text-black']">
                    {{ pg_event }}
                  </button> -->

                  <button
                    type="button"
                    @click="nexPage_event"
                    :disabled="
                      Math.ceil(table.total_event / table.per_page_event) ===
                        table.current_page_event
                    "
                    class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  >
                    <span class="sr-only">Next</span>
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </nav>
              </div>
            </div>

            <!-- ----------------- -->
            <!-- Destination Table -->
            <!-- ----------------- -->
            <h1 class="text-2xl mt-10">Destination</h1>
            <div class="mt-2 my-5">
              <table class="w-full mx-auto table-auto">
                <thead class="justify-between">
                  <tr class="bg-gray-600">
                    <th class="px-5 py-2">
                      <span class="text-gray-100 font-semibold">No</span>
                    </th>
                    <th class="px-16 py-2">
                      <span class="text-gray-100 font-semibold">Name</span>
                    </th>
                    <th class="px-16 py-2">
                      <span class="text-gray-100 font-semibold"
                        >Choose one destination to highlight</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-gray-200">
                  <tr
                    v-for="(sos, index) in destinations"
                    :key="sos.id"
                    :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
                    class="bg-white border-b-2 border-gray-200"
                  >
                    <td class="px-5 py-2 text-center">
                      {{
                        table.current_page_destination === 1
                          ? index + 1
                          : index +
                            1 +
                            (table.current_page_destination - 1) *
                              table.per_page_destination
                      }}
                    </td>
                    <td class="text-center">
                      <button
                        class="font-bold text-app-default"
                        type="button"
                        @click="detailDestinationContent(sos.id)"
                      >
                        {{ sos.destination_name }}
                      </button>
                    </td>
                    <td class="">
                      <div
                        class="flex items-center justify-evenly"
                        v-if="sos.id === deployedDestinationId"
                      >
                        <span class="text-sm text-dark mb-3 font-bold">
                          Selected
                        </span>
                      </div>
                      <div class="flex items-center justify-evenly" v-else>
                        <button
                          class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
                          type="button"
                          @click="updateDeployedDestination(sos.id)"
                        >
                          Select
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- ----------------- -->
            <!-- Destination Pagination -->
            <!-- ----------------- -->
            <div
              class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"
            >
              <div>
                <p class="text-sm text-gray-700">
                  Showing
                  <span class="font-medium">
                    {{
                      table.current_page_destination *
                        table.per_page_destination -
                        table.per_page_destination +
                        1
                    }}
                  </span>
                  to
                  <span class="font-medium">
                    {{
                      table.current_page_destination *
                        table.per_page_destination
                    }}
                  </span>
                  of
                  <span class="font-medium">{{ table.total_destination }}</span>
                  results
                </p>
              </div>
              <div>
                <nav
                  class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                  aria-label="Pagination"
                >
                  <button
                    type="button"
                    @click="previewPage_destination"
                    :disabled="table.current_page_destination === 1"
                    class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  >
                    <span class="sr-only">Previous</span>
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>

                  <div
                    v-if="
                      Math.ceil(
                        table.total_destination / table.per_page_destination
                      ) < 5
                    "
                    class=""
                  >
                    <button
                      v-for="pg_destination in Math.ceil(
                        table.total_destination / table.per_page_destination
                      )"
                      :key="pg_destination"
                      @click="findpage_destination(pg_destination)"
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_destination === pg_destination
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{ pg_destination }}
                    </button>
                  </div>
                  <div v-else class="">
                    <button
                      @click="findpage_destination(1)"
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_destination === 1
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      1
                    </button>

                    <button
                      @click="
                        findpage_destination(
                          table.current_page_destination === 1
                            ? 2
                            : table.current_page_destination === 2
                            ? 2
                            : table.current_page_destination ===
                              Math.ceil(
                                table.total_destination /
                                  table.per_page_destination
                              )
                            ? table.current_page_destination - 3
                            : table.current_page_destination ===
                              Math.ceil(
                                table.total_destination /
                                  table.per_page_destination
                              ) -
                                1
                            ? table.current_page_destination - 2
                            : table.current_page_destination - 1
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(
                          table.total_destination / table.per_page_destination
                        ) -
                          1 ===
                          table.current_page_destination
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_destination === 1
                          ? 'bg-white text-black'
                          : table.current_page_destination === 2
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{
                        table.current_page_destination === 1
                          ? 2
                          : table.current_page_destination === 2
                          ? 2
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            )
                          ? table.current_page_destination - 3
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            ) -
                              1
                          ? table.current_page_destination - 2
                          : table.current_page_destination - 1
                      }}
                    </button>

                    <button
                      @click="
                        findpage_destination(
                          table.current_page_destination === 1
                            ? 3
                            : table.current_page_destination === 2
                            ? 3
                            : table.current_page_destination ===
                              Math.ceil(
                                table.total_destination /
                                  table.per_page_destination
                              ) -
                                1
                            ? table.current_page_destination - 1
                            : table.current_page_destination ===
                              Math.ceil(
                                table.total_destination /
                                  table.per_page_destination
                              )
                            ? table.current_page_destination - 2
                            : table.current_page_destination
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(
                          table.total_destination / table.per_page_destination
                        ) -
                          1 ===
                          table.current_page_destination
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_destination ===
                        Math.ceil(
                          table.total_destination / table.per_page_destination
                        ) -
                          1
                          ? 'bg-white text-black'
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            )
                          ? 'bg-white text-black'
                          : table.current_page_destination === 1
                          ? 'bg-white text-black'
                          : table.current_page_destination === 2
                          ? 'bg-white text-black'
                          : 'bg-app-default text-white',
                      ]"
                    >
                      {{
                        table.current_page_destination === 1
                          ? 3
                          : table.current_page_destination === 2
                          ? 3
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            ) -
                              1
                          ? table.current_page_destination - 1
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            )
                          ? table.current_page_destination - 2
                          : table.current_page_destination
                      }}
                    </button>

                    <button
                      @click="
                        findpage_destination(
                          table.current_page_destination === 1
                            ? 4
                            : table.current_page_destination === 2
                            ? 4
                            : table.current_page_destination ===
                              Math.ceil(
                                table.total_destination /
                                  table.per_page_destination
                              ) -
                                1
                            ? Math.ceil(
                                table.total_destination /
                                  table.per_page_destination
                              ) - 1
                            : table.current_page_destination ===
                              Math.ceil(
                                table.total_destination /
                                  table.per_page_destination
                              )
                            ? table.current_page_destination - 1
                            : table.current_page_destination + 1
                        )
                      "
                      type="button"
                      aria-current="page"
                      :disabled="
                        Math.ceil(
                          table.total_destination / table.per_page_destination
                        ) -
                          1 ===
                          table.current_page_destination
                      "
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_destination ===
                        Math.ceil(
                          table.total_destination / table.per_page_destination
                        ) -
                          2
                          ? 'bg-white text-black'
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            ) -
                              3
                          ? 'bg-white text-black'
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            )
                          ? 'bg-white text-black'
                          : table.current_page_destination > 1 &&
                            table.current_page_destination <
                              Math.ceil(
                                table.total_destination /
                                  table.per_page_destination
                              ) -
                                1
                          ? 'bg-white text-black'
                          : table.current_page_destination === 1
                          ? 'bg-white text-black'
                          : 'bg-app-default text-white',
                      ]"
                    >
                      {{
                        table.current_page_destination === 1
                          ? 4
                          : table.current_page_destination === 2
                          ? 4
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            ) -
                              1
                          ? Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            ) - 1
                          : table.current_page_destination ===
                            Math.ceil(
                              table.total_destination /
                                table.per_page_destination
                            )
                          ? table.current_page_destination - 1
                          : table.current_page_destination + 1
                      }}
                    </button>

                    <button
                      @click="
                        findpage_destination(
                          Math.ceil(
                            table.total_destination / table.per_page_destination
                          )
                        )
                      "
                      type="button"
                      aria-current="page"
                      class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                      :class="[
                        table.current_page_destination ===
                        Math.ceil(
                          table.total_destination / table.per_page_destination
                        )
                          ? 'bg-app-default text-white'
                          : 'bg-white text-black',
                      ]"
                    >
                      {{
                        Math.ceil(
                          table.total_destination / table.per_page_destination
                        )
                      }}
                    </button>
                  </div>
                  <!-- <button v-for="pg_destination in Math.ceil(table.total_destination / table.per_page_destination)" :key="pg_destination" @click="findpage_destination(pg_destination)" type="button" aria-current="page" class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium" :class="[table.current_page_destination === pg_destination ? 'bg-app-default text-white' : 'bg-white text-black']">
                    {{ pg_destination }}
                  </button> -->

                  <button
                    type="button"
                    @click="nexPage_destination"
                    :disabled="
                      Math.ceil(
                        table.total_destination / table.per_page_destination
                      ) === table.current_page_destination
                    "
                    class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                  >
                    <span class="sr-only">Next</span>
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Facility</div>
            <div @click="showModalFacility" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="">
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Title
              <div class="ml-8 font-normal">{{ facility.title }}</div>
            </div>
            <div class="mb-5 font-bold">
              <fas icon="building" class="mr-3" />
              Description
              <!-- <div class="ml-8 font-normal">{{ facility.description }}</div> -->
              <div class="ml-8 font-normal" v-html="facility.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal news -->
    <div
      v-if="modalNews"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalNews"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Edit News Description
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Title</label>
                <input
                  v-model="title"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
                  placeholder="Title"
                />
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="description"
                  rows="8"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                  placeholder="Promo Description"
                ></textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                >
                  <CKEditor
                    v-model="description"
                    :disabled="false"
                    :toolbar="toolbar"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ description?.length }} used out of 2000 characters
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalNews"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateNewsInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalNews"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal facility -->
    <div
      v-if="modalFacility"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalFacility"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Edit Facility Description
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Title</label>
                <input
                  v-model="title"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
                  placeholder="Title"
                />
              </div>
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Description</label
                >
                <!-- <textarea
                  v-model="description"
                  rows="8"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                  placeholder="Promo Description"
                ></textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200"
                >
                  <CKEditor
                    v-model="description"
                    :disabled="false"
                    :toolbar="toolbar"
                  />
                </div>
                <div
                  class="text-right text-sm "
                  :class="[
                    description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ description?.length }} used out of 2000 characters
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalFacility"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updateFacilityInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalFacility"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import CKEditor from "../../components/CKEditor.vue";
import Warning from "../../components/Warning.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Information",
  components: { Warning, CKEditor, SuccessNotif },
  data() {
    return {
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      modalNews: false,
      modalFacility: false,
      news: {},
      facility: {},
      title: "",
      description: "",
      saveButton: "Save",
      promotions: [],
      events: [],
      destinations: [],
      deployedPromoId: null,
      deployedEventId: null,
      deployedDestinationId: null,
      table: {
        current_page: 1,
        per_page: 5,
        search: "",
        total: 0,
        current_page_event: 1,
        per_page_event: 5,
        search_event: "",
        total_event: 0,
        current_page_destination: 1,
        per_page_destination: 5,
        search_destination: "",
        total_destination: 0,
      },
    };
  },
  methods: {
    showModalNews: function() {
      this.title = this.news.title;
      this.description = this.news.description;
      this.modalNews = !this.modalNews;
    },
    showModalFacility: function() {
      this.title = this.facility.title;
      this.description = this.facility.description;
      this.modalFacility = !this.modalFacility;
    },
    findNewsInfo: async function() {
      try {
        let res = await fetch(`${API}v1/info-news`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.news = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findFacilityInfo: async function() {
      try {
        let res = await fetch(`${API}v2/info-facility`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.facility = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    updateNewsInfo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/news/info/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.news.id,
            title: this.title,
            description: this.description,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
        }
        this.modalNews = false;
        this.saveButton = "Save";
        this.findNewsInfo();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateFacilityInfo: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/facility/info/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.facility.id,
            title: this.title,
            description: this.description,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this._error("internal server error");
        }
        this.modalFacility = false;
        this.saveButton = "Save";
        this.findFacilityInfo();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },

    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    nexPage: function() {
      this.table.current_page = this.table.current_page + 1;
      this.findPromotions();
    },
    previewPage: function() {
      this.table.current_page = this.table.current_page - 1;
      this.findPromotions();
    },
    findpage: function(page) {
      this.table.current_page = page;
      this.findPromotions();
    },
    nexPage_event: function() {
      this.table.current_page_event = this.table.current_page_event + 1;
      this.findEvent();
    },
    previewPage_event: function() {
      this.table.current_page_event = this.table.current_page_event - 1;
      this.findEvent();
    },
    findpage_event: function(page) {
      this.table.current_page_event = page;
      this.findEvent();
    },
    nexPage_destination: function() {
      this.table.current_page_destination =
        this.table.current_page_destination + 1;
      this.findDestination();
    },
    previewPage_destination: function() {
      this.table.current_page_destination =
        this.table.current_page_destination - 1;
      this.findDestination();
    },
    findpage_destination: function(page) {
      this.table.current_page_destination = page;
      this.findDestination();
    },
    findPromotions: async function() {
      try {
        let res = await fetch(
          `${API}v1/admin/cms/promotion?current_page=${this.table.current_page}&per_page=${this.table.per_page}&search=${this.table.search}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.promotions = respon.data.promotions;
        this.table.current_page = respon.data.current_page;
        this.table.per_page = respon.data.per_page;
        // this.table.search = respon.data.search
        this.table.total = respon.data.total;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findDeployedPromo: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/displayed_promo`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status === "failed") {
          return;
        }
        this.deployedPromoId = respon.data.id;
      } catch (err) {
        this._error("internal server error");
      }
    },
    updateDeployedPromo: async function(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/displayed_promo/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go();
          return;
        }
        // console.log(respon);
        this.findPromotions();
        this.findDeployedPromo();
      } catch (err) {
        this._error("Internal server error");
        this.$router.go();
      }
    },
    detailContent: function(id) {
      this.$router.push({
        path: this.$route.path + "/promo/" + id,
        query: {
          deployedPromoId: this.deployedPromoId,
        },
      });
    },
    detailEventContent: function(id) {
      this.$router.push({
        path: this.$route.path + "/event/" + id,
        query: {
          deployedEventId: this.deployedEventId,
        },
      });
    },
    detailDestinationContent: function(id) {
      this.$router.push({
        path: this.$route.path + "/destination/" + id,
        query: {
          deployedDestinationId: this.deployedDestinationId,
        },
      });
    },
    findEvent: async function() {
      try {
        let res = await fetch(
          `${API}v1/admin/cms/event?current_page=${this.table.current_page_event}&per_page=${this.table.per_page_event}&search=${this.table.search_event}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.events = respon.data.events;
        this.table.current_page_event = respon.data.current_page;
        this.table.per_page_event = respon.data.per_page;
        // this.table.search_event = respon.data.search
        this.table.total_event = respon.data.total;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findDeployedEvent: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/event/displayed_event`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status === "failed") {
          return;
        }
        this.deployedEventId = respon.data.id;
      } catch (err) {
        this._error("internal server error");
      }
    },
    updateDeployedEvent: async function(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      try {
        let res = await fetch(`${API}v1/admin/cms/event/displayed_event/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go();
          return;
        }
        this.findEvent();
        this.findDeployedEvent();
      } catch (err) {
        this._error("Internal server error");
        this.$router.go();
      }
    },
    findDestination: async function() {
      try {
        let res = await fetch(
          `${API}v1/admin/cms/destination?current_page=${this.table.current_page_destination}&per_page=${this.table.per_page_destination}&search=${this.table.search_destination}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.destinations = respon.data.destinations;
        this.table.current_page_destination = respon.data.current_page;
        this.table.per_page_destination = respon.data.per_page;
        // this.table.search_destination = respon.data.search
        this.table.total_destination = respon.data.total;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findDeployedDestination: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/displayed_destination`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status === "failed") {
          return;
        }
        this.deployedDestinationId = respon.data.id;
      } catch (err) {
        this._error("internal server error");
      }
    },
    updateDeployedDestination: async function(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      try {
        let res = await fetch(`${API}v1/admin/cms/destination/displayed_destination/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go();
          return;
        }
        // console.log(respon);
        this.findDestination();
        this.findDeployedDestination();
      } catch (err) {
        this._error("Internal server error");
        this.$router.go();
      }
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findPromotions();
    this.findEvent();
    this.findDestination();
    this.findDeployedPromo();
    this.findDeployedEvent();
    this.findDeployedDestination();
    this.findNewsInfo();
    this.findFacilityInfo();
  },
};
</script>
